import createHttp from '@/config/http';
import type {
	BillingToolsProducts,
	BillingToolsProductsResponse,
	MisbilledHCPCS,
	MisbilledHCPCSResponse,
	MisbilledUnits,
	MisbilledUnitsResponse,
	UnmatchedClaimsToInvoices,
	UnmatchedClaimsToInvoicesResponse,
	UnmatchedInvoicesToClaim,
	UnmatchedInvoicesToClaimsResponse,
} from '@/types/billingTools';
import type { ResponseMetaData } from '@/types/service';

// localhost:3003
// Use full URL from environment variable
const http = createHttp(import.meta.env.VITE_INVOICE_URL);

export const getMisbilledHCPCS = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
): Promise<{
	items: MisbilledHCPCS[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<MisbilledHCPCSResponse>(
		'/billing-tools/miss-billed-hcpcs',
		{
			params: {
				page,
				limit,
				columnsFilters,
				search,
				globalFilters,
				sort,
				dateRangeFilter,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getMisbilledUnits = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
): Promise<{
	items: MisbilledUnits[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<MisbilledUnitsResponse>(
		'/billing-tools/mismatch-billing-units',
		{
			params: {
				page,
				limit,
				columnsFilters,
				search,
				globalFilters,
				sort,
				dateRangeFilter,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getUnmatchedClaimsToInvoices = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
): Promise<{
	items: UnmatchedClaimsToInvoices[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<UnmatchedClaimsToInvoicesResponse>(
		'/billing-tools/unmatched-claims-to-invoices',
		{
			params: {
				page,
				limit,
				columnsFilters,
				search,
				globalFilters,
				sort,
				dateRangeFilter,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getUnmatchedInvoicesToClaims = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
): Promise<{
	items: UnmatchedInvoicesToClaim[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<UnmatchedInvoicesToClaimsResponse>(
		'/billing-tools/unmatched-invoices-to-claim',
		{
			params: {
				page,
				limit,
				columnsFilters,
				search,
				globalFilters,
				sort,
				dateRangeFilter,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getMisbilledUnitsProducts = async (
	globalFilters = '[]',
): Promise<{
	items: BillingToolsProducts[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<BillingToolsProductsResponse>(
		'/billing-tools/mismatch-billing-units-products',
		{
			params: {
				globalFilters,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getMisbilledHCPCSProducts = async (
	globalFilters = '[]',
): Promise<{
	items: BillingToolsProducts[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<BillingToolsProductsResponse>(
		'/billing-tools/miss-billed-hcpcs-products',
		{
			params: {
				globalFilters,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getUnmatchedInvoicesToClaimsProducts = async (
	globalFilters = '[]',
): Promise<{
	items: BillingToolsProducts[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<BillingToolsProductsResponse>(
		'/billing-tools/unmatched-invoices-to-claim-products',
		{
			params: {
				globalFilters,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};
